import { Component } from '@angular/core';
import { LanguageSelectorBase } from '../language-selector.base';

@Component({
  selector: 'fgbcl-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent extends LanguageSelectorBase{

}
